'use client';

import { usePathname, useRouter } from 'next/navigation';
import React, { useEffect } from 'react';
import BottomNav from 'componentsUnits/bottomNav';
import { NextPage } from 'next';
import { isDev } from 'app/general';
import MenuManager from './menuManager';
import { resetGoToPage } from 'actions/general';
import { useAppDispatch, useAppSelector } from 'reducers/storeHooks';
import { isUrlAuth, isUrlAvailableForNonUsers, isUrlGeneral, isUrlOnBoarding } from 'helpers/general';
import { Capacitor } from '@capacitor/core';
import { authPages } from 'helpers/auth';
import NotLoggedInComponent from 'components/notLoggedInComponent';

const homePage = '/home';

interface Props {
  children: React.ReactNode; // Use React.ReactNode for children prop type
}

const NavManager: NextPage<Props> = ({ children }) => {
  const router = useRouter();
  const pathname = usePathname() || '';
  const user = useAppSelector((state) => state.userReducer.user);
  const tokenLoading = useAppSelector((state) => state.userReducer.tokenLoading);
  const goToPage = useAppSelector((state) => state.mainReducer.goToPage);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (Capacitor.getPlatform() === 'ios') {
      document.documentElement.style.setProperty('--header-size', '120px');
    }
  }, []);

  useEffect(() => {
    if (tokenLoading) return;
    if (user) {
      handleLoggedInUserNavigation();
    } else {
      handleLoggedOutUserNavigation();
    }

    if (goToPage) {
      router.push(goToPage);
      dispatch(resetGoToPage());
    }
  }, [goToPage, user, tokenLoading, dispatch]);

  const handleLoggedInUserNavigation = () => {
    isDev && console.log('NavManager: show logged in pages only');
    if (authPages.includes(pathname) || pathname === '/onboarding') {
      router.push(homePage);
    }
  };

  const isHideBottomNav = () => {
    return isUrlAuth(pathname) || isUrlOnBoarding(pathname);
  }

  const handleLoggedOutUserNavigation = () => {
    isDev && console.log('NavManager: navigating for logged out users');
    if (isUrlAvailableForNonUsers(pathname)) {
      isDev && console.log('NavManager: show pages available for non-users');
    } else if (pathname === '/') {
      router.push('/onboarding');
    } else if (!authPages.includes(pathname)) {
      router.replace('/auth/login');
    }
  };

  return (
    <>
      {user
        ?
        (
          <>
            <MenuManager />
            {children}
            {!isHideBottomNav() && <BottomNav />}
            {/* <div style={{ position: "fixed", bottom: 0, top: 0, backgroundColor: "red", width: "100%", height: 50, zIndex: 99999999 }}>
              <div>{pathname}</div>
              <div>{user.uid}</div>
            </div> */}
          </>
        )
        :
        (
          isUrlAuth(pathname) || isUrlAvailableForNonUsers(pathname) ?
            (
              <>
                {children}
                {!isHideBottomNav() && <BottomNav />}
                {/* <div style={{ position: "fixed", bottom: 0, top: 0, backgroundColor: "red", width: "100%", height: 50, zIndex: 99999999 }}>
                  <div>{pathname}</div>
                  <div>{"SSS"}</div>
                </div> */}
              </>
            )
            :
            (
              <>
                <NotLoggedInComponent text="brizup" disableBack />
                {/* <div style={{ position: "fixed", bottom: 0, top: 0, backgroundColor: "red", width: "100%", height: 50, zIndex: 99999999 }}>
                  <div>{pathname}</div>
                  <div>{"BBB"}</div>
                </div> */}
              </>

            )
        )
      }

    </>
  );
};

export default NavManager;
